<template>
  <div class="isStylePageContent isPaddingBottom">
    <div :class="$style.subTitleDisplay">
      <el-button size="small" :class="[$style.backBtn, $style.btnNoStyle]" @click="backToInfo">
        <i class="fa fa-angle-left fa-icon" aria-hidden="true"></i>
      </el-button>
      <h4>{{ subTitle }}</h4>
    </div>
    <el-input v-model.trim.lazy="goodsName" :placeholder="'搜尋商品名稱'" style="margin-bottom: 20px;"
      class="is-border bg-white" :class="$style.searchBtn">
      <el-button slot="append" icon="el-icon-search" @click="searchByUser"></el-button>
    </el-input>
    <el-select v-model="goodsTagsValue" style="margin-bottom: 20px;" multiple filterable allow-create default-first-option
      placeholder="請選擇商品標籤">
      <el-option v-for="item in goodsTagsOption" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>

    <div v-if="categoryType === 'category'" :class="$style.container">
      <div v-for="(category, index) in currentList" :key="index" :class="$style.contentText"
        @click="goNextCategory(category)">
        {{ category.title }}
      </div>
    </div>

    <div v-if="categoryType === 'product'" :class="$style.container">
      <div v-for="(item, index) in productList" :key="index" :class="$style.contentImgItem" @click="goDetail(index)">
        <div :class="$style.imgAndP">
          <img v-if="item.image" :src="item.image" />
          <img v-else :src="require(`@assets/images/icons/face-cream.svg`)" />
          <p class="title">{{ item.title }}</p>
          <p class="subTitle">{{ item.petCategoryTitle }}</p>
        </div>
      </div>
    </div>

    <div :class="$style.footer">
      <el-button class="is-round" type="primary" :disabled="inventoryList.length === 0" @click="completeGoodsSelect">完成{{
        purchaseText }}商品選擇</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PurchaseCategory',
  props: {
    categoryType: {
      type: String,
    },
    /**
     * @description 進貨or退貨的中文字
     */
    purchaseText: {
      type: String,
      require: true,
      default: '',
    },
    currentList: {
      type: Array,
      require: true,
      default: () => {
        return []
      },
    },
    productList: {
      type: Array,
      require: true,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      goodsName: '',
      filterLabel: '',
      goodsTagsOption: [],
      goodsTagsValue: [], // 標籤的值
    }
  },
  computed: {
    inventoryList() {
      return this.$store.state.inventory.list
    },
    subTitle() {
      return this.currentList[0]?.categoryTitle
    },
  },
  async mounted() {
    await this.fetchTagsName();
  },
  methods: {
    /**
     * @description 回到第一層的類別
     */
    backToInfo(){
      this.$emit('resetCategory')
    },
    /**
     * @description 完成商品選擇
     */
    completeGoodsSelect() {
      this.$emit('backToCategoryType', 'category')
    },
    /**
     * @description 使用者去搜尋商品
     */
    async searchByUser() {
      const { items } = await this.$store.dispatch('product/fetchNormalServiceData', {
        types: ['goods'],
        paginate: 0,
        tagIds: this.getTagsId(),
        search: this.goodsName
      })
      this.goNextCategory(null, items)
    },
    getTagsId() {
      let result = this.goodsTagsValue.reduce((accu, cur) => {
        const { id } = this.goodsTagsOption.find(item => item.value === cur)
        if (id) {
          accu.push(id)
        }
        return accu
      }, [])
      return result
    },
    /**
     * @description 取得所有標籤中文名稱
     */
    async fetchTagsName() {
      try {
        const { items } = await this.$store.dispatch("mixTag/mixTagSearch", {
          search: "",
          type: "goods",
          paginate: 0,
        });
        this.goodsTagsOption = []; // 先清空選項
        items.forEach((item) => {
          this.goodsTagsOption.push({
            value: item.title,
            label: `${item.title}`,
            id: item.id,
          });
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 使用者點擊到商品
     */
    goNextCategory(category, itemsList = []) {
      this.$emit('goNextCategory', category, itemsList)
    },
    /**
     * @description 到商品細節（點擊商品）
     */
    goDetail(index) {
      this.$emit('goDetail', index)
    },
  },
}
</script>

<style lang="scss" module>

.btnNoStyle {
  border: none;
  background-color: transparent;

  &:hover,
  &:focus {
    background-color: transparent;
  }
}
.container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
}

.contentText {
  width: 23.5%;
  height: 175px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $color-text-placeholder;
  margin-right: 13px;
  margin-bottom: 13px;
  color: $color-primary;
  flex-shrink: 0;
  border-radius: $border-radius;

  &:hover {
    cursor: pointer;
  }
}

.contentImgItem {
  display: flex;
  /* 自動平均分配寬度 */
  max-width: calc(20% - 30px);
  /* 20% 寬度减去 padding */
  min-width: calc(20% - 30px);
  margin: 15px;

  >div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    p {
      margin-top: 0;
      margin-bottom: 0;
    }

    :global {
      .title {
        color: $color-secondary;
        font-size: 14px;
        margin-bottom: 7px;
        margin-top: 10px;
      }
    }
  }
}

.contentImgItemSearch {}

.contentImgItemSearch {}

.subTitleDisplay {
  display: flex;
  flex-direction: row;
  align-items: center;

  >span {
    margin-right: 20px;
  }
}

.footer {
  padding: 20px 40px;
  width: calc(100% - 72px);
  position: fixed;
  left: 72px;
  bottom: 0;
  display: flex;
  gap: 10px;
  box-shadow: 3px -3px 10px #00000019;
  background-color: #fff;
  z-index: 2;

  :global {
    button {
      flex: 1;
    }
  }
}

.imgAndP {
  :global {
    img {
      width: 160px;
      height: 90px;
    }
  }
}
.backBtn {
  border: none;
  :global {
    i {
      font-size: 15px;
    }
  }
}
.searchBtn {
  :global {
    .el-input-group__append {
      position: absolute;
      top: 23%;
      right: 1%;
    }
  }
}
</style>
